import axios from "axios";
import { MessageBox, Message } from "element-ui";
import store from "@/store";
import router from "@/router";
import { getToken } from "@/utils/auth";

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 0, // request timeout
});

// const pendingRequests = new Map();
// const canRepeatUrl = ["/out/file", "/uploadfile"];
// request interceptor
service.interceptors.request.use(
  (config) => {
    // 除开文件上传的接口，其他接口避免重复请求
    // if (canRepeatUrl.indexOf(config.url) === -1) {
    //   const url =
    //     config.url + (config.params ? JSON.stringify(config.params) : "");
    //   const cancelTokenSource = axios.CancelToken.source();
    //   if (pendingRequests.has(url)) {
    //     // 取消前一个请求
    //     pendingRequests
    //       .get(url)
    //       .cancel("Operation canceled due to new request.");
    //   }
    //   // 设置新的取消令牌
    //   config.cancelToken = cancelTokenSource.token;
    //   // 更新请求映射表
    //   pendingRequests.set(url, cancelTokenSource);
    // }
    // do something before request is sent
    if (store.state.user.token && getToken()) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers["Authorization"] = "Bearer " + getToken();
    }
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const contentDisposition = response.headers["content-disposition"];

    // 判断是否为文件下载
    const isDownload =
      contentDisposition && contentDisposition.indexOf("attachment") !== -1;
    if (isDownload) {
      return response;
    }
    // if(!response.code){
    //   return response
    // }

    const res = response.data;
    if(!res.code){
      return res
    }

    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 200) {
      Message({
        message: res.msg || "Error",
        type: "error",
        duration: 5 * 1000,
      });

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm(
          "You have been logged out, you can cancel to stay on this page, or log in again",
          "Confirm logout",
          {
            confirmButtonText: "Re-Login",
            cancelButtonText: "Cancel",
            type: "warning",
          }
        ).then(() => {
          store.dispatch("user/resetToken").then(() => {
            location.reload();
          });
        });
      }
      return Promise.resolve((res.msg || "Error"));
    } else {
      return res;
    }
  },
  (error) => {
    if (error.code === "ERR_CANCELED") {
      return Promise.resolve();
    }
    if (error.status === 403) {
      store.dispatch("user/resetInfo");
      // router.push(`/login?redirect=${router.currentRoute.fullPath}`);
      router.push(`/login`);
      // router.push('/login');
      return Promise.resolve(error);
    } else {
      console.log("err" + error); // for debug
      Message({
        message: error.message,
        type: "error",
        duration: 5 * 1000,
      });
      return Promise.reject(error);
    }
  }
);

export default service;
